import { GetResourceBundlePathOptions } from './types';

export const GetResourceBundlePath = ({
  bundleName,
}: GetResourceBundlePathOptions): string => `/v1/resource/bundle/${bundleName}`;
